import styled from 'styled-components';

export const Arrow = styled.div`
  & svg path {
    fill: ${props => props.fill && props.fill};
  }
`;
